import { initCommonStaticPageSentry } from "../utils/sentry/static-page";
import "../tailwind.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { initBootstrapBehaviors } from "../vendor/bootstrap-behaviors";
import { ready } from "../utils/document-ready";
import { rigFormSubmitButtonDoubleClickBlock } from "../utils/block-dbclick-btn-form";
import { rigDetailsCloseOnOutsideClick } from "./details-outside-click.js";

initCommonStaticPageSentry();

// eslint-disable-next-line @typescript-eslint/require-await -- Keep a uniform async page rig entrypoint across static pages even when this page's setup is currently synchronous.
async function rig(): Promise<void> {
    const pageRoot = document.querySelector<HTMLElement>("[data-ocp-basic-page-root]");
    if (pageRoot) {
        initBootstrapBehaviors(pageRoot);
    }
    rigFormSubmitButtonDoubleClickBlock();
    rigDetailsCloseOnOutsideClick();
}

ready(rig);
